import { render, staticRenderFns } from "./PayBox.vue?vue&type=template&id=f9893c68&scoped=true&"
import script from "./PayBox.vue?vue&type=script&lang=js&"
export * from "./PayBox.vue?vue&type=script&lang=js&"
import style0 from "./PayBox.vue?vue&type=style&index=0&id=f9893c68&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9893c68",
  null
  
)

export default component.exports